import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import normalizeAiContent from '../utils/normalizeAiContent';

interface MarkdownViewProps {
  content: string;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Canonical renderer for AI-generated Markdown. Replaces the ad-hoc
 * `<pre>{content}</pre>` blocks scattered across the AI pages so output is
 * formatted (headings, lists, tables) instead of shown as raw text/JSON.
 */
const MarkdownView: React.FC<MarkdownViewProps> = ({ content, className, style }) => (
  <div className={`markdown-content${className ? ` ${className}` : ''}`} style={style}>
    <ReactMarkdown remarkPlugins={[remarkGfm]}>{normalizeAiContent(content || '')}</ReactMarkdown>
  </div>
);

export default MarkdownView;
